import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { ParticipantComponent } from "../../components/participant"

export const ParticipantPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <ParticipantComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}